import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var SocialContent = styled.div.withConfig({
  displayName: "SocialContent",
  componentId: "sc-2d65cj-0"
})(["display:flex;justify-content:space-between;min-width:fit-content;margin-bottom:48px;", ";background-color:", ";color:#fff;a{display:inline-block;opacity:0.8;margin-right:14px;color:#fff;&:hover{opacity:1;}svg{width:24px;height:24px;}}a:last-child{margin-right:0;}"], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["margin-bottom: 20px;"]))), function (_ref) {
  var theme = _ref.theme;
  return theme.footerColor;
});